export function getCMSLocations() {
    return {
        type: 'getCMSLocations',
    }
}

export function getCMSVehicles() {
    return {
        type: 'getCMSVehicles',
    }
}

export function getCMSOptions() {
    return {
        type: 'getCMSOptions',
    }
}

export function getCMSCovers() {
    return {
        type: 'getCMSCovers',
    }
}

export function getCMSLocales() {
    return {
        type: 'getCMSLocales',
    }
}

export function getCMSPartners() {
    return {
        type: 'getCMSPartners',
    }
}

export function getCMSRegions() {
    return {
        type: 'getCMSRegions',
    }
}

export function getCMSAges() {
    return {
        type: 'getCMSAges',
    }
}

export function getCMSSwitchboards() {
    return {
        type: 'getCMSSwitchboards',
    }
}

export function clearPromocode() {
    return {
        type: 'clearPromocode',
    }
}

export function checkPromocode(params) {
    return {
        ...params,
        type: 'checkPromocode',
    }
}

export function checkRelocation(params) {
    return {
        ...params,
        type: 'checkRelocation',
    }
}
